import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchLabels = () => api.get("/labels").then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchCaseStudies = () => api.get("/case-studies").then((r) => r.data);
export const fetchCaseStudy = (slug) => api.get(`/case-studies/${slug}`).then((r) => r.data);
export const fetchCampaigns = () => api.get("/campaigns").then((r) => r.data);
export const fetchCreators = (params) => api.get("/creators", { params }).then((r) => r.data);
export const fetchInsights = (params) => api.get("/insights", { params }).then((r) => r.data);
export const fetchInsight = (slug) => api.get(`/insights/${slug}`).then((r) => r.data);
export const fetchCareers = () => api.get("/careers").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitApplication = (payload) => api.post("/careers/apply", payload).then((r) => r.data);
